import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { CameraOff } from "lucide-react";

const REGION_ID = "bltr-qr-reader";

// Camera-based QR scanner. Calls onScan(decodedText) once on a successful read.
export function QRScanner({ onScan }) {
  const scannerRef = useRef(null);
  const handledRef = useRef(false);
  const [error, setError] = useState("");
  const [starting, setStarting] = useState(true);

  useEffect(() => {
    let mounted = true;
    const scanner = new Html5Qrcode(REGION_ID, { verbose: false });
    scannerRef.current = scanner;

    const stop = async () => {
      try {
        if (scanner && scanner.getState && scanner.getState() === 2) {
          await scanner.stop();
        }
        scanner.clear();
      } catch (e) { /* ignore */ }
    };

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 240, height: 240 } },
        (decodedText) => {
          if (handledRef.current) return;
          handledRef.current = true;
          stop().finally(() => onScan(decodedText));
        },
        () => {} // per-frame decode failure — ignore
      )
      .then(() => mounted && setStarting(false))
      .catch((err) => {
        if (!mounted) return;
        setStarting(false);
        setError(
          err?.toString().includes("NotAllowedError")
            ? "Akses kamera ditolak. Izinkan kamera lalu coba lagi."
            : "Kamera tidak tersedia di perangkat ini. Gunakan input manual di bawah."
        );
      });

    return () => { mounted = false; stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div
        id={REGION_ID}
        className="w-full rounded-2xl overflow-hidden bg-slate-900 aspect-square max-w-xs mx-auto [&_video]:object-cover"
        data-testid="qr-scanner-region"
      />
      {starting && !error && (
        <p className="mt-3 text-center text-sm font-semibold text-slate-500">Menyalakan kamera…</p>
      )}
      {error && (
        <div className="mt-3 flex items-start gap-2 bg-destructive/10 text-destructive rounded-xl px-4 py-3 text-sm font-bold" data-testid="qr-scanner-error">
          <CameraOff className="w-5 h-5 shrink-0" /> {error}
        </div>
      )}
    </div>
  );
}
